export default __webpack_public_path__ + "static/media/9.479d8926.png";